var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('main-header',{attrs:{"currentStep":_vm.currentStep}}),_c('div',{staticClass:"container",staticStyle:{"min-height":"400px"}},[_vm._t("default")],2),_c('main-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }